import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

import OneDragToScroll from '@/modules/module-oneDragToScroll';

export default Backbone.View.extend({
  initialize: function (opts) {
    console.log("init blog listing page");

    var self = this;
    self.$content = self.$el;
    self.$blogFiltering = self.$content.find('.blog-filtering');

    if (self.$blogFiltering.length > 0) {
      self.blogFiltering();
    }
  },

  events: {
    'click .pagination-load-more-btn': async function (event) {
      const loadMore = document.querySelector('.blog-pagination');
      const loadMoreButton = document.querySelector('.blog-pagination .pagination-load-more-btn');
      const nextUrl = loadMoreButton.dataset.nextUrl;

      const response = await fetch(nextUrl);

      if (!response.ok) {
        loadMoreButton.innerText = 'Failed to load';
        loadMoreButton.classList.add('.pagination-load-more-btn-disabled');
        loadMoreButton.disabled = true;
      }

      const html = await response.text();

      const parser = new DOMParser();
      const nextPageDocument = parser.parseFromString(html, 'text/html');
      const newArticles = nextPageDocument.querySelectorAll('.article-card');
      const newLoadMore = nextPageDocument.querySelector('.blog-pagination');

      if (newArticles.length > 0) {
        newArticles.forEach(article => {
          document.querySelector('.blog-articles').appendChild(article);
        });
      } 

      if (newLoadMore) {
        loadMore.replaceWith(newLoadMore);
      }
    }
  },

  blogFiltering: function () {
    var self = this;
    
    self.$blogFiltering.each(function (index, module){
        module && OneDragToScroll(module, 600, false);
    })
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  responsive: function () {
    var self = this;
    ORW.utilities.mediaCheck(
      function () {
        // Desktop actions
      },
      function () {
        // Mobile actions
      }
    );
  },

  isMobile: function () {
    if (ORW.responsive == "small") {
      return true;
    }
    return false;
  },
});
